import { Autocomplete, Chip, TextField } from "@mui/material";
import React, { useState } from "react";
import { CloseIcon } from "../Icons";

interface IEmailInputWithChipsProps {
 emails: string[];
 setEmails: (emails: string[]) => void;
 label: string;
}
const EmailInputWithChips = ({ emails, setEmails, label }: IEmailInputWithChipsProps) => {
  const [error, setError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState("");
  const isValidEmail = (email: string): boolean =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const handleChange = (
    event: React.SyntheticEvent | null,
    newValue: string[],
  ) => {
    // If the change was a deletion, just update the emails
    if (newValue.length < emails.length) {
      setEmails(newValue);

      return;
    }

    const lastInput = newValue[newValue.length - 1];

    // Split by comma and trim
    const splitEmails = lastInput ?
      lastInput.split(",").map((e) => e.trim()).filter((e) => e) :
      [];

    const allValid = splitEmails.every(isValidEmail);

    if (!allValid) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 4000);
    } else {
      setError(false);
      setEmails([...new Set([...emails, ...splitEmails])]);
    }
  };

  const handleSetEmail = () => {
    handleChange(null, [...emails, inputValue.trim()]);
    setInputValue("");
  };
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === " ") {
      event.preventDefault(); // Prevent the default space behavior
      if (inputValue.trim() !== "") {
        handleSetEmail();
      }
    }
  };

  const handleInputChange = (event: React.SyntheticEvent, newInputValue: string) => {
    setInputValue(newInputValue);
  };

  return (
    <div>
      <label className="text-xs font-semibold block mb-1">{label}</label>
      <Autocomplete
        multiple
        clearIcon={false}
        freeSolo
        options={[]}
        value={emails}
        inputValue={inputValue}
        onChange={handleChange}
        onInputChange={handleInputChange}
        renderTags={(value: string[], props) =>
          value.map((option: string, index: number) => (
            // eslint-disable-next-line react/jsx-key
            <Chip
              label={option}
              deleteIcon={<CloseIcon width={18} height={18} color="black"
                className="hover:cursor-pointer hover:bg-zinc-100 hover:rounded-full" />}
              {...props({ index })}
              style={{ backgroundColor: isValidEmail(option) ? "#e8dfd7" : "error" }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={emails.length > 0 ? "" : "Add one or more emails (Press space or enter to add)"}
            error={error}
            helperText={error ? "* Please ensure all email addresses are properly formatted" : ""}
            onKeyDown={handleKeyDown}
          />
        )}
      />
    </div>
  );
};

export default EmailInputWithChips;
